(function () {
    'use strict';

    function EventExceptionDurationController($scope, $state, translate, translatePartialLoader, $mdDialog) {
        var $ctrl = this;
        $ctrl.newDate = null;

        $ctrl.addDuration = addDuration;
        $ctrl.removeDuration = removeDuration;
        $ctrl.startDate = new Date();
        $ctrl.endDate = new Date();
        $ctrl.startTime;
        $ctrl.endTime;
        $ctrl.availablityMode = 'OPEN';

        Date.prototype.toLocalISOString = function () {
            var mm = this.getMonth() + 1; // getMonth() is zero-based
            var dd = this.getDate();
            if (mm < 10) mm = '0' + mm;
            if (dd < 10) dd = '0' + dd;

            return [this.getFullYear(), mm, dd].join('-'); // padding
        };


        function setOffDate() {
            //
            if ($ctrl.selectedDatePeriod != undefined) {
                $ctrl.selectedDatePeriod.offdays = [];
                angular.forEach($ctrl.offDates, function (val) {
                    var dateTemp = new Date(val.value);
                    if (dateTemp)
                        $ctrl.selectedDatePeriod.offdays.push({offDate: dateTemp.toLocalISOString()});
                });
            }
        }

        function addDuration() {
            if (!$ctrl.exdurations)
                $ctrl.exdurations = [];
            var dur = makeDurationObject();
            if (dur && $ctrl.startDate != null && $ctrl.endDate != null) {

                var persianDate = new JDate($ctrl.newDate);
                var hasAddedBefore = false;
                angular.forEach($ctrl.exdurations, function (val) {
                    if (val.startDate && val.endDate && val.startDate.toLocaleString() == $ctrl.startDate.toLocaleString() &&
                        ((!val.startTime && !$ctrl.startTime) || (val.startTime && $ctrl.startTime && val.startTime.toLocaleString() == $ctrl.startTime.toLocaleString())) &&
                        val.endDate.toLocaleString() == $ctrl.endDate.toLocaleString() &&
                        ((!val.endTime && !$ctrl.endTime) || (val.endTime && $ctrl.endTime && val.endTime.toLocaleString() == $ctrl.endTime.toLocaleString()))
                    )

                        hasAddedBefore = true;
                });
                if (!hasAddedBefore) {

                    $ctrl.exdurations.push(dur);
                } else {
                    alert('بازه زمانی مشخص شده تکراری است');
                }
            }
        }

        function alert(msg) {
            $mdDialog.show(
                $mdDialog.alert()
                    //  .parent(angular.element(document.querySelector('#addExceptionDuration')))
                    .clickOutsideToClose(true)
                    .title('خطا')
                    .textContent(msg)
                    .ariaLabel('error')
                    .ok('بستن')
                    .targetEvent(null)
            );
        }

        function makeDurationObject(ev) {
            $ctrl.endDate = $ctrl.startDate;

            if (!$ctrl.startTime || !$ctrl.endTime) {
                alert('ساعت شروع و پایان را وارد کنید');
                return null;
            } else {

                return {
                    availablityMode: $ctrl.availablityMode,
                    startDate: $ctrl.startDate,
                    endDate: $ctrl.endDate,
                    startTime: $ctrl.startTime,
                    endTime: $ctrl.endTime
                };
            }

        }

        function removeDuration(date) {
            if ($ctrl.exdurations != undefined)
                $ctrl.exdurations = $ctrl.exdurations.filter(function (item) {
                    return item != date;
                });
        }


    }

    var EventExceptionDuration = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/event-exception-duration/partial-form.event-exception-duration.html',
        controller: EventExceptionDurationController,
        bindings: {
            exdurations: '=',
            eventDuration: '=',
        }

    };

    angular
        .module('tikonApp')
        .component('pfEventExceptionDuration', EventExceptionDuration)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    EventExceptionDurationController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', '$mdDialog'];


})();

